module.exports = __webpack_public_path__ + "static/media/teenage_dirtbag_pluspunkt.5dbf41c5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/snippets/teenage_dirtbag_pluspunkt.mp3
// module id = 189
// module chunks = 0